define.alias("shared/models/fb-post", "calendar/models/fb-post");